<template>
    <div>
        <h1>CARTE</h1>
        <div id="mapContainer"
        style="
                position: absolute;
                width: 100%;
                height: 100%;
            "
        ></div>
    </div>
</template>

<script>
import Resource from "@/api/resource";
//import { Map, NavigationControl, Marker, config, Popup } from 'maplibre-gl';
import { Map, NavigationControl, Popup } from 'maplibre-gl';
import '@maptiler/sdk/dist/maptiler-sdk.css';

const userResource = new Resource("users");

export default {
    name: "Options",
    components: { },
    data() {
        return {
            loading: false,
            map: null,
            mybounds: null,
            UsersFeatCol: null
        };
    },
    created() {
        console.log("getUsers");
        this.getUsersForMap();
    },
    mounted() {

        this.map = new Map({
            container: 'mapContainer',
            // style: `https://api.maptiler.com/maps/streets-v2/style.json?key=${apiKey}`,
            // style: `https://api.maptiler.com/maps/toner-v2/style.json?key=${apiKey}`,

            //PERSONALISER
            //https://cloud.maptiler.com/maps/
            //https://cloud.maptiler.com/maps/editor?map=45b3c1f4-f3ea-4841-8813-98df026665f4#13.06/40.39374/-3.66746
            // style: `https://api.maptiler.com/maps/45b3c1f4-f3ea-4841-8813-98df026665f4/style.json?key=${apiKey}`,

            //style: 'https://demotiles.maplibre.org/style.json', // stylesheet location

            //ArcGIS Hybrid Basemap // pas mal satellite
            //style: 'https://raw.githubusercontent.com/go2garret/maps/main/src/assets/json/arcgis_hybrid.json',

            //OpenStreetMap Basemap
            //style: 'https://raw.githubusercontent.com/go2garret/maps/main/src/assets/json/openStreetMap.json',


            //Dark Matter //PAS MAL
            //style: 'https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json',
            //Dark Matter No Labels
            //style: 'https://basemaps.cartocdn.com/gl/dark-matter-nolabels-gl-style/style.json',
            //Positron //cool simple
            //style: 'https://basemaps.cartocdn.com/gl/positron-gl-style/style.json',
            //Positron No Labels
            //style: 'https://basemaps.cartocdn.com/gl/positron-nolabels-gl-style/style.json',
            //Voyager
            style: 'https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json',
            //Voyager No Labels
            //style: 'https://basemaps.cartocdn.com/gl/voyager-nolabels-gl-style/style.json',

            center: [5, 46], // starting position [lng, lat]
            zoom: 5 // starting zoom
        });
        this.map.addControl(new NavigationControl(), 'top-left');

    },
    watch: {},
    methods: {

        async getUsersForMap() {
            console.log("getOptions");
            this.loading = true;
            const  data  = await userResource.list({usersformap:1});
            console.log("UsersFeatColllllll");
            console.log(data.FeatureCollection);
            this.UsersFeatCol = data.FeatureCollection;
            this.loading = false;
            this.putMarks ();
        },

        putMarks () {
            if(this.UsersFeatCol){
                this.map.addSource('users', {
                        'type': 'geojson',
                        'data': this.UsersFeatCol,
                        cluster: true,
                        clusterMaxZoom: 14, // Max zoom to cluster points on
                        clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)

                    });
                    console.log('putMarks');
                    console.log(this.map.getSource('users'));

                    this.map.addLayer({
                        'id': 'users',
                        'type': 'circle',
                        'source': 'users',
                        'filter': ['has', 'point_count'],
                        paint: {
                            // Use step expressions (https://maplibre.org/maplibre-style-spec/#expressions-step)
                            // with three steps to implement three types of circles:
                            //   * Blue, 20px circles when point count is less than 100
                            //   * Yellow, 30px circles when point count is between 100 and 750
                            //   * Pink, 40px circles when point count is greater than or equal to 750
                            'circle-color': [
                                'step',
                                ['get', 'point_count'],
                                '#51bbd6',
                                100,
                                '#f1f075',
                                750,
                                '#f28cb1'
                            ],
                            'circle-radius': [
                                'step',
                                ['get', 'point_count'],
                                20,
                                100,
                                30,
                                750,
                                40
                            ]
                        }
                    });


                    this.map.addLayer({
                        id: 'cluster-count',
                        type: 'symbol',
                        source: 'users',
                        filter: ['has', 'point_count'],
                        layout: {
                            'text-field': '{point_count_abbreviated}',
                            'text-size': 12
                        }
                    });

                    this.map.addLayer({
                        id: 'unclustered-point',
                        type: 'circle',
                        source: 'users',
                        filter: ['!', ['has', 'point_count']],
                        paint: {
                            'circle-color': '#11b4da',
                            'circle-radius': 4,
                            'circle-stroke-width': 1,
                            'circle-stroke-color': '#fff'
                        }
                    });

                    // inspect a cluster on click
                    this.map.on('click', 'users', async (e) => {
                        const features = this.map.queryRenderedFeatures(e.point, {
                            layers: ['users']
                        });
                        const clusterId = features[0].properties.cluster_id;
                        const zoom = await this.map.getSource('users').getClusterExpansionZoom(clusterId);
                        this.map.easeTo({
                            center: features[0].geometry.coordinates,
                            zoom
                        });
                    });

                    // When a click event occurs on a feature in
                    // the unclustered-point layer, open a popup at
                    // the location of the feature, with
                    // description HTML from its properties.
                    this.map.on('click', 'unclustered-point', (e) => {

                        console.log(e.features[0].properties.user_id);

                        let userlabel = '<a href="/allocataires/edit/' + e.features[0].properties.user_id + '">' +
                            e.features[0].properties.user_name + ' ' + e.features[0].properties.user_prenom +
                            '</a>';
                        const coordinates = e.features[0].geometry.coordinates.slice();
                        // Ensure that if the map is zoomed out such that
                        // multiple copies of the feature are visible, the
                        // popup appears over the copy being pointed to.
                        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                        }

                        new Popup()
                            .setLngLat(coordinates)
                            .setHTML(
                                userlabel
                            )
                            .addTo(this.map);
                    });

                    this.map.on('mouseenter', 'users', () => {
                        this.map.getCanvas().style.cursor = 'pointer';
                    });
                    this.map.on('mouseleave', 'users', () => {
                        this.map.getCanvas().style.cursor = '';
                    });











            }

        }
    }
};
</script>
